export default __webpack_public_path__ + "116931e38cbb0876aadf280dc17d9b77.png";